<script>
    import { flow_steps, dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip, userNotification, updatePropertyZipInfo } from './stores.js';
    import * as yup from 'yup'; 
    import { debounce } from 'lodash';
    import { onMount } from "svelte";
    import {querystring, link, location, push, pop, replace} from 'svelte-spa-router';
    
    import Overlay from "./components/overlaycomponent.svelte";

    import CTA from './components/ctacomponent.svelte';
    import FooterComponent from './components/footercomponent.svelte';
    // const superagent = require('superagent');

    // let purpose = "Purchase";
    // let purpose = $user_data.loantype;
    let term = "30-year fixed";
    let selected_rate_data = [];
    let rate_data = [];

    // let zipcode;
    let purchase_price = "";
    let down_payment_amount = "";
    let down_payment_percent = "";
    $: {
        if(purchase_price !== "") $user_data.purchaseprice = purchase_price.toString().replace(/[^\d.-]/g, '');
    }
    $: {
        if(down_payment_amount !== "") $user_data.downpaymentamount = down_payment_amount.toString().replace(/[^\d.-]/g, '');
    }
    $: {
        if(down_payment_percent !== "") $user_data.down_payment_percent = down_payment_percent.toString().replace(/[^\d.-]/g, '');
    }

    let zipcode_element;
    let purchase_price_element;
    let down_payment_amount_element;
    let down_payment_percent_element;
    let credit_score_element;
    let property_value_element;
    let current_balance_element;

    const purchase_formSchema = yup.object().shape({
        zipcode_element: yup
        .string()
        .required('Zip code is required to find the best rates.')
        .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, 'Invalid zip code format'),
        purchase_price_element: yup
        .number()
        .required('The purchase price is required to find the best rates.')
        .typeError('The purchase price must be a number'),
        credit_score_element: yup
        .number()
        .required('Estimated credit score is required to find the best rates.')
        .typeError('Credit score must be a number')
        .min(300, "Estimated credit score hast to be between 300 and 850")
        .max(850, "Estimated credit score hast to be between 300 and 850"),
    });    

    const refi_formSchema = yup.object().shape({
        zipcode_element: yup
        .string()
        .required('Zip code is required to find the best rates.')
        .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, 'Invalid zip code format'),
        property_value_element: yup
        .number()
        .required('The property value is required to find the best rates.')
        .typeError('The property value must be a number'),
        current_balance_element: yup
        .number()
        .typeError('The current balance must be a number')
        .required('The current balance is required to find the best rates.'),
        credit_score_element: yup
        .number()
        .required('Estimated credit score is required to find the best rates.')
        .typeError('Credit score must be a number')
        .min(300, "Estimated credit score hast to be between 300 and 850")
        .max(850, "Estimated credit score hast to be between 300 and 850"),
    });    

    let bottom_container_element;

    const scrollToHelp = () => {
        console.log(bottom_container_element.getBoundingClientRect());
        const c = bottom_container_element.getBoundingClientRect().y ;
        if (c > 100) {
            window.requestAnimationFrame(scrollToHelp);
            window.scrollBy(0, c - c / 8);
        }
    };    

    function doNoProductsFound(){
        scrollToHelp();
        userNotification("error", "Error:", "Sorry, we couldn’t find rates for your scenario, please talk to us");

    }

    function doSetPopups(){
console.log("############ DOING popups!")
    // const button = document.querySelector('.monthlypopuptarget');
    //   const tooltip = document.querySelector('#payment_tooltip');

    //   const popperInstance = Popper.createPopper(button, tooltip);
    //   console.log(popperInstance);
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

    function formatEverything(){
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '').trim();
        const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '').trim();
        const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '').trim();

        const tpv = property_value.toString().replace(/[^\d.-]/g, '').trim();
        const tcb = current_balance.toString().replace(/[^\d.-]/g, '').trim();

        if(tpp.length > 0){
            purchase_price = `$${tpp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        if(tdpa.length > 0){
            down_payment_amount = `$${tdpa.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        if(tdpp.length > 0){
            down_payment_percent = `${tdpp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
        }
        if(tpv.length > 0){
            property_value = `$${tpv.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
        if(tcb.length > 0){
            current_balance = `$${tcb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }

    }

    let debouncedPurchasePriceChanged = debounce(purchasePriceChanged, 100);
    let debouncedDownPaymentAmountChanged = debounce(downPaymentAmountChanged, 100);
    let debouncedDownPaymentPercentChanged = debounce(downPaymentPercentChanged, 100);
    let debouncedFormatter = debounce(formatEverything, 100);

    function purchasePriceChanged() {
        clearFunction();
        const tpp = purchase_price_element.value.replace(/[^\d.-]/g, '');
        const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '');
        const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tpp)) {
            if(parseFloat(tdpa)) {
                down_payment_percent = Math.round((parseFloat(tdpa) / parseFloat(tpp)) * 100.0);
                if(down_payment_percent > 100) down_payment_percent = 100;
            } else if(parseFloat(tdpp)) {
                down_payment_amount = Math.round(tpp * parseFloat(tdpp));
            }
        }

        debouncedFormatter();

        }

    function downPaymentAmountChanged() {
        clearFunction();
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '');
        const tdpa = down_payment_amount_element.value.toString().replace(/[^\d.-]/g, '');
        // const tdpp = down_payment_percent.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tdpa) && parseFloat(tpp)){
                down_payment_percent = Math.round((parseFloat(tdpa) / parseFloat(tpp)) * 100.0);
        }
        debouncedFormatter();

    }

    function downPaymentPercentChanged() {
        clearFunction();
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '');
        // const tdpa = down_payment_amount.toString().replace(/[^\d.-]/g, '');
        const tdpp = down_payment_percent_element.value.toString().replace(/[^\d.-]/g, '');

        if(parseFloat(tdpp) && parseFloat(tpp)){
                down_payment_amount = Math.round(parseFloat(tpp) * (1/100) * parseFloat(tdpp));
        }
        debouncedFormatter();
    }

    let property_value = "";
    let current_balance = "";
    $: {
        if(property_value !== "") $user_data.propertyvalue = property_value.toString().replace(/[^\d.-]/g, '');
    }
    $: {
        if(current_balance !== "") $user_data.currentbalance = current_balance.toString().replace(/[^\d.-]/g, '');
    }

    let debouncedPropertyValueChanged = debounce(propertyValueChanged, 100);
    let debouncedCurrentBalanceChanged = debounce(currentBalanceChanged, 100); 

    function propertyValueChanged() {
        debouncedFormatter();
    }

    function currentBalanceChanged() {
        debouncedFormatter();
    }

    // let current_balance;
    // let credit_score;
    // let is_military = false;
    // let property_type;
    // let first_time_buyer = false;

    onMount(async() => {
        NProgress.configure({ showSpinner: false });
        const params = new URLSearchParams($querystring)

        if (params.has("f")) {
            const flow_type = params.get("f");
            if(flow_type.startsWith("iq")){
                setTimeout(() => {
                    doSeeRates();
                }, 1000);
            }
        }


        if($user_data.loantype == "Purchase"){
            purchase_price = $user_data.purchaseprice;
            down_payment_amount = $user_data.downpaymentamount;
            down_payment_percent = $user_data.downpaymentpercentage;
            debouncedPurchasePriceChanged();
        }else{
            property_value = $user_data.propertyvalue;
            current_balance = $user_data.currentbalance;
        }
    });


    let show_overlay = false;
    let step_1_hidden = "";
    let step_2_hidden = "stephidden";
    let step_3_hidden = "stephidden";
    let step_4_hidden = "stephidden";

    function showProgress() {
        step_1_hidden = "";
        step_2_hidden = "stephidden";
        step_3_hidden = "stephidden";
        step_4_hidden = "stephidden";

        show_overlay = true;

        // setTimeout(() => {
        //     step_2_hidden = "";
        // }, 1000);
        // setTimeout(() => {
        //     step_3_hidden = "";
        // }, 2000);
        // setTimeout(() => {
        //     step_4_hidden = "";
        // }, 3000);
        setTimeout(() => {
            show_overlay = false;
        }, 4000);
    }
    
//     setTimeout(() => {
//         rate_data = [        
//         {"t": "30-year fixed", "r": "2.375%", "a": "2.578%", 
//     }, 5000);


    function isEmptyOrSpaces(str){
        return str === undefined || str === null || str.match(/^ *$/) !== null;
    }


    function doSeeRates() {
        // clearFunction();
        if($user_data.loantype === "Refinance"){
            refi_formSchema.validate({
                zipcode_element: zipcode_element.value.trim(),
                property_value_element: property_value_element.value.replace(/[^\d.-]/g, '').trim(),
                current_balance_element: current_balance_element.value.replace(/[^\d.-]/g, '').trim(),
                credit_score_element: credit_score_element.value.trim(),
                }).then(function (value) {
                    /// check refi fields here
                    dbClearAllInvalidItems();
                    if(
                        parseInt(property_value_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
                        parseInt(property_value_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 10000000

                    ){
                        if(
                            parseInt(current_balance_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
                            parseInt(current_balance_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 2000000
                        ){
                            doRateSearch();
                        }else{
                            invalidateItem(current_balance_element, "The current balance must be between $0 and $2,000,000")
                        }

                    }else{
                        invalidateItem(property_value_element, "The property value must be between $0 and $10,000,000")
                    }

            }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            });
        }else{
            /// check purchase fields here

            //first check purchase price
            if(
                parseInt(purchase_price_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
                parseInt(purchase_price_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 10000000
            ){
                //then check downpayment amount
                if(
                    parseInt(down_payment_amount_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
                    parseInt(down_payment_amount_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 2000000

                ){
                    //then check total loan amount
                    if(
                        (parseInt(purchase_price_element.value.trim().toString().replace(/[^\d.-]/g, "")) - parseInt(down_payment_amount_element.value.trim().toString().replace(/[^\d.-]/g, ""))) >= 50000 &&
                        (parseInt(purchase_price_element.value.trim().toString().replace(/[^\d.-]/g, "")) - parseInt(down_payment_amount_element.value.trim().toString().replace(/[^\d.-]/g, ""))) <= 2000000

                    ){
                        //check zip code
                        if(
                            /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode_element.value.trim()) 
                        ){
                            doRateSearch();
                        }else{
                            invalidateItem(zipcode_element, "The zip code is required to get the best prices.");
                        }
                    }else{
                        invalidateItem(purchase_price_element, "The total loan amount must be between $50,000 and $2,000,000");
                    }
                }else{
                    invalidateItem(down_payment_amount_element, "The downpayment amount must be between between $0 and $2,000,000");
                }
            }else{
                invalidateItem(purchase_price_element, "The purchase price must be between $0 and $10,000,000");
            }



            // purchase_formSchema.validate({
            //     zipcode_element: zipcode_element.value.trim(),
            //     purchase_price_element: purchase_price_element.value.replace(/[^\d.-]/g, '').trim(),
            //     credit_score_element: credit_score_element.value.replace(/[^\d.-]/g, '').trim(),
            //     }).then(function (value) {
            //         doRateSearch();
            // }).catch(function (err) {
            //     console.log(err);
            //     invalidateItem(eval(err.path), err.errors[0]);
            // });
        }


    }

    // const scrollToTop = () => {
    //     console.log(window.getBoundingClientRect());
    //     const c = window.getBoundingClientRect().y ;
    //     console.log(`window y: ${c}`);
    //     if (c > 100) {
    //         window.requestAnimationFrame(scrollToTop);
    //         window.scrollBy(0, c - c / 8);
    //     }
    // };    
    const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollTo(0, c - c / 8);
        }
    };



    async function doRateSearch() {
console.log("doing rate search");
    scrollToTop();
    NProgress.start();

        console.log("before zip update");
        await updatePropertyZipInfo(zipcode_element.value.trim());
        console.log("after zip update");

        // counteyChecker(true);
        // console.log("... before search rate_data is");
        // console.log(rate_data);

        let get_rates = false;
        let error_message = "Unknown error.";
        let search_data = {};
        selected_rate_data = [];
        rate_data = [];

        
        refilogic: if($user_data.loantype === "Refinance"){

// console.log(`zipcode: ${zipcode}`);
// console.log(`purchase_price: ${purchase_price}`);
// console.log(`down_payment_amount: ${down_payment_amount}`);
// console.log(`down_payment_percent: ${down_payment_percent}`);
// console.log(`property_value: ${property_value}`);
// console.log(`current_balance: ${current_balance}`);
// console.log(`credit_score: ${credit_score}`);
// console.log(`is_military: ${is_military}`);
// console.log(`property_type: ${property_type}`);
// console.log(`first_time_buyer: ${first_time_buyer}`);

        search_data = {
            "borrowerInformation": {
                "assetDocumentation": "Verified",
                "citizenship": "USCitizen",
                "employmentDocumentation": "Verified",
                "incomeDocumentation": "Verified",
                "monthsReserves": 12
            },
            "loanInformation": {
                "amortizationTypes": [
                    "Fixed"
                ],
                "automatedUnderwritingSystem": "DU",
                "baseLoanAmount": $user_data.currentbalance.toString().replace(/[^\d.-]/g, '').trim(),
                "borrowerPaidMI": "Yes",
                "buydown": "None",
                "calculateTotalLoanAmount": true,
                "expandedApprovalLevel": "NotApplicable",
                "includeLOCompensationInPricing": "NoBuyerPaid",
                "interestOnly": false,
                "lienType": "First",
                "loanPurpose": "RefiRateTermLimitedCO",
                "loanTerms": [
                    "ThirtyYear",
                    "TwentyYear",
                    "FifteenYear"
                ],
                "loanType": "Conventional",
                "prepaymentPenalty": "None"
            },
            "propertyInformation": {
                "appraisedValue": $user_data.propertyvalue.toString().replace(/[^\d.-]/g, '').trim(),
                "occupancy": "PrimaryResidence",
                "county": $user_data.propertycounty,
                "state": $user_data.propertystate,
                "zipCode": $user_data.propertyzipcode,
                "propertyType": "SingleFamily",
                "corporateRelocation": false,
                "salesPrice": $user_data.propertyvalue.toString().replace(/[^\d.-]/g, '').trim(),
                "numberOfStories": 1,
                "numberOfUnits": "OneUnit"
            },
            "representativeFICO": $user_data.creditscore.toString().replace(/[^\d]/g, '').trim(),
            "loanLevelDebtToIncomeRatio": 20.0,
            "customerInternalId": "OBSearch"
        };

            if($user_data.firsttimebuyer){
                search_data.borrowerInformation.firstTimeHomeBuyer = true;
            }

            // do checks here
            // const dpp = ($user_data.down_payment_percent !== "") ? $user_data.down_payment_percent : "0";
            const fico = parseInt($user_data.creditscore);
            const isprimary = ($user_data.hometype.toLowerCase().includes("primary")) ? true : false;
            const iscashout = ($user_data.cashoutamount !== "" && parseInt($user_data.cashoutamount) > 0) ? true : false;
            const pv = parseInt($user_data.propertyvalue.toString().replace(/[^\d.-]/g, '').trim());
            const la = parseInt($user_data.currentbalance.toString().replace(/[^\d.-]/g, '').trim());
            const ltv = la / pv;

            console.log(`fico: ${fico}`);
            console.log(`isprimary: ${isprimary}`);
            console.log(`iscashout: ${iscashout}`);
            console.log(`pv: ${pv}`);
            console.log(`la: ${la}`);
            console.log(`ltv: ${ltv}`);
            

            if($user_data.military){
                console.log("... adding military");
                search_data.borrowerInformation.typeOfVeteran = "ActiveDuty";
                $user_data.loanType = "VA";
                search_data.loanInformation.loanType = "VA";
                search_data.borrowerInformation.vaFirstTimeUse = true;
                search_data.loanInformation.exemptFromVAFundingFee = false;
            }else{
                console.log("... skipping military");
// console.log(`fico <= 640: ${fico <= 640}`);
// console.log(`isprimary: ${isprimary}`);
// console.log(`ltv <= 0.9775: ${ltv <= 0.9775}`);
// console.log(`fha qualifier: ${( fico <= 640 && isprimary && ltv <= 0.9775 )}`);

                if( fico <= 640 && isprimary && ltv <= 0.9775 ){
                    $user_data.loanType = "FHA";
                    search_data.loanInformation.loanType = "FHA";

                }else{
                    $user_data.loanType = "Conventional";
                    search_data.loanInformation.loanType = "Conventional";
                }

            }
            
            if($user_data.propertytype === "Condo"){
                search_data.propertyInformation.propertyType = property_type;
                search_data.propertyInformation.numberOfStories = 1;
                search_data.propertyInformation.numberOfUnits = "OneUnit"
            }
            if($user_data.propertytype === "Multi-unit"){
                search_data.propertyInformation.numberOfStories = 2;
                search_data.propertyInformation.numberOfUnits = "OneUnit"
                search_data.propertyInformation.propertyType = "Townhouse";
            }
            
            // if(isEmptyOrSpaces(zipcode)){
            //     error_message = "Missing zipcode";
            //     break refilogic;
            // }
            if(isEmptyOrSpaces(property_value)){
                error_message = "Missing property value";
                break refilogic;
            }
            if(isEmptyOrSpaces($user_data.currentbalance)){
                error_message = "Missing current_balance";
                break refilogic;
            }
            if(isEmptyOrSpaces($user_data.creditscore)){
                error_message = "Missing credit score";
                break refilogic;
            }

            get_rates = true;
        }else{
            // console.log("... trying to do purchase")
            // userNotification('error', 'Error:', "Only refinance rates for now!");
            purchaselogic: if($user_data.loantype === "Purchase"){
                // console.log("... doing purchase")
                // console.log("$user_data.purchaseprice: ", $user_data.purchaseprice);
                // console.log("$user_data.downpaymentamount: ", $user_data.downpaymentamount);
                // console.log("baseLoanAmount: ", (parseFloat($user_data.purchaseprice.toString().replace(/[^\d.-]/g, '').trim()) - parseFloat($user_data.downpaymentamount.toString().replace(/[^\d.-]/g, '').trim())).toLocaleString().toLocaleString('en-US', {style: 'currency', currency: 'USD'}).replace(/[^\d.-]/g, '').trim());
                
                // break purchaselogic;

                // set purchase options
                search_data = {
                    "borrowerInformation": {
                        "assetDocumentation": "Verified",
                        "citizenship": "USCitizen",
                        "employmentDocumentation": "Verified",
                        "incomeDocumentation": "Verified",
                        "monthsReserves": 12
                    },
                    "loanInformation": {
                        "amortizationTypes": [
                            "Fixed"
                        ],
                        "automatedUnderwritingSystem": "DU",
                        // "baseLoanAmount": $user_data.currentbalance.toString().replace(/[^\d.-]/g, '').trim(),
                        "baseLoanAmount": (parseFloat($user_data.purchaseprice.toString().replace(/[^\d.-]/g, '').trim()) - parseFloat($user_data.downpaymentamount.toString().replace(/[^\d.-]/g, '').trim())).toLocaleString().toLocaleString('en-US', {style: 'currency', currency: 'USD'}).replace(/[^\d.-]/g, '').trim(),
                        "borrowerPaidMI": "Yes",
                        "buydown": "None",
                        "calculateTotalLoanAmount": true,
                        "expandedApprovalLevel": "NotApplicable",
                        "includeLOCompensationInPricing": "NoBuyerPaid",
                        "interestOnly": false,
                        "lienType": "First",
                        "loanPurpose": "Purchase",
                        "loanTerms": [
                            "ThirtyYear",
                            "TwentyYear",
                            "FifteenYear"
                        ],
                        "loanType": "Conventional" ,
                        "prepaymentPenalty": "None"
                    },
                    "propertyInformation": {
                        "appraisedValue": $user_data.purchaseprice.toString().replace(/[^\d.-]/g, '').trim(),
                        "occupancy": ($user_data.hometype === "") ? "PrimaryResidence" : $user_data.hometype,
                        "county": $user_data.propertycounty,
                        "state": $user_data.propertystate,
                        "zipCode": $user_data.propertyzipcode,
                        "propertyType": "SingleFamily",
                        "corporateRelocation": false,
                        "salesPrice": $user_data.purchaseprice.toString().replace(/[^\d.-]/g, '').trim(),
                        "numberOfStories": 1,
                        "numberOfUnits": "OneUnit"
                    },
                    "representativeFICO": $user_data.creditscore.toString().replace(/[^\d]/g, '').trim(),
                    "loanLevelDebtToIncomeRatio": 20.0,
                    "customerInternalId": "OBSearch"
                };

                if(search_data.loanInformation.baseLoanAmount > 647200){
                    $user_data.loanType = "NonConforming";
                    search_data.loanInformation.loanType = "NonConforming";
                        
                }

                if($user_data.firsttimebuyer){
                search_data.borrowerInformation.firstTimeHomeBuyer = true;
                }


                // do checks here
                const dpp = ($user_data.down_payment_percent !== "") ? $user_data.down_payment_percent : "0";
                const fico = parseInt($user_data.creditscore);
                const isprimary = ($user_data.hometype.toLowerCase().includes("primary")) ? true : false;

                // console.log(`dpp: ${dpp}`);
                // console.log(`fico: ${fico}`);
                // console.log(`isprimary: ${isprimary}`);

                // search_data.loanInformation.loanType = "FHA";


                if($user_data.military){
                    console.log("... adding military");
                    search_data.borrowerInformation.typeOfVeteran = "ActiveDuty";
                    $user_data.loanType = "VA";
                    search_data.loanInformation.loanType = "VA";
                    search_data.borrowerInformation.vaFirstTimeUse = true;
                    search_data.loanInformation.exemptFromVAFundingFee = false;
                }else{
                    console.log("... skipping military");
                    
                    ///test if FHA
                    if(fico <= 640 && dpp >= 3.5 && isprimary){
                        $user_data.loanType = "FHA";
                        search_data.loanInformation.loanType = "FHA";
                    }
                }
                
                if($user_data.propertytype === "Condo"){
                    search_data.propertyInformation.propertyType = property_type;
                    search_data.propertyInformation.numberOfStories = 2;
                    search_data.propertyInformation.numberOfUnits = "TwoUnits"
                }
                if($user_data.propertytype === "Multi-unit"){
                    search_data.propertyInformation.numberOfStories = 2;
                    search_data.propertyInformation.numberOfUnits = "ThreeUnits"
                    search_data.propertyInformation.propertyType = "Condo";
                }
                

// console.log("purchase_price: ", purchase_price);
// console.log("downpayment: ", $user_data.downpaymentamount);
// console.log("creditscore: ", $user_data.creditscore);

                if(isEmptyOrSpaces(purchase_price)){
                error_message = "Missing purchase price";
                break purchaselogic;
                }
                if(isEmptyOrSpaces($user_data.downpaymentamount)){
                    error_message = "Missing down payment amount";
                    break purchaselogic;
                }
                if(isEmptyOrSpaces($user_data.creditscore)){
                    error_message = "Missing credit score";
                    break purchaselogic;
                }

                get_rates = true;
            }
        }



        if(get_rates){
            // showProgress();
            // NProgress.start();

console.log(search_data);
        superagent
        .post('/api/obapi')
        .send({ action: 'rates', search_data: search_data }) // sends a JSON post body
        .set('accept', 'json')
        .end((err, res) => {
            NProgress.done();

            if(err !== null){
                // userNotification('error', 'Error:', err.toString());
                userNotification('error', 'Error:', 'No loans found. Please give us a call to find a perfect rate for you');
            }else{
// console.log(res.text)
                res = JSON.parse(res.text);
                if(!res.st){
                    // userNotification('error', 'Error:', res.msg);
                    userNotification('error', 'Error:', 'No loans found. Please give us a call to find a perfect rate for you');
                }else{
                    const rdata = res.data;
                    console.log(rdata);
                    if(rdata.products.length > 0){
                    const term30tmp = rdata.products.filter((e) => {return e.amortizationTerm === "30" && e.price >= 98});
                    const term20tmp = rdata.products.filter((e) => {return e.amortizationTerm === "20" && e.price >= 98});
                    const term15tmp = rdata.products.filter((e) => {return e.amortizationTerm === "15" && e.price >= 98});

                    let term30 = [];
                    let term20 = [];
                    let term15 = [];
                    term30.push(term30tmp.find(x=>x.price >= 98));
                    term30.push(term30tmp.find(x=>x.price >= 99));
                    term30.push(term30tmp.find(x=>x.price >= 100));

                    term20.push(term20tmp.find(x=>x.price >= 98));
                    term20.push(term20tmp.find(x=>x.price >= 99));
                    term20.push(term20tmp.find(x=>x.price >= 100));

                    term15.push(term15tmp.find(x=>x.price >= 98));
                    term15.push(term15tmp.find(x=>x.price >= 99));
                    term15.push(term15tmp.find(x=>x.price >= 100));
                    // const term30 = rdata.products.filter((e) => {return e.amortizationTerm === "30" && e.rebate === 0}).slice(-1 * 3);
                    // const term20 = rdata.products.filter((e) => {return e.amortizationTerm === "20" && e.rebate === 0}).slice(-1 * 3);
                    // const term15 = rdata.products.filter((e) => {return e.amortizationTerm === "15" && e.rebate === 0}).slice(-1 * 3);
                    
                    // term30 = term30.filter((v,i,a)=>a.findIndex(t=>(t.productId === v.productId))===i);
                    // term20 = term20.filter((v,i,a)=>a.findIndex(t=>(t.productId === v.productId))===i);
                    // term15 = term15.filter((v,i,a)=>a.findIndex(t=>(t.productId === v.productId))===i);


                    const matched_data = [term30, term20, term15];
                    // console.log(matched_data);

                    const trdata = [];
                    for(let j = 0; j < matched_data.length; j++){
                        const pd = matched_data[j];
                        if(pd !== undefined){
                            for(let i = 0; i < pd.length; i++) {
                                let ni = pd[i];
// console.log(ni);
                                if(ni !== undefined){
                                    ni['idx'] = i;
                                    ni["t"] = `${ni.amortizationTerm}-year ${ni.amortizationType.toLowerCase()}`,
                                    ni["r"] = `${ni.rate.toFixed(3)}%`,
                                    ni["a"] = `${ni.apr.toFixed(3)}%`,
                                    ni["po"] = `$${Math.round(ni.discount).toLocaleString(undefined, {minimumFractionDigits: 0})}`,
                                    ni["mp"] = `$${Math.round(ni.totalPayment).toLocaleString(undefined, {minimumFractionDigits: 0})}`
                                    // "po": `$${ni.discount.toLocaleString(undefined, {minimumFractionDigits: 2})}`,
                                    // "mp": `$${ni.totalPayment.toLocaleString(undefined, {minimumFractionDigits: 2})}`

                                    trdata.push(ni);

                                }
                            }

                        }

                    }

// console.log(trdata);
                    if(trdata.length > 0){
                        setTimeout(() => {
                            rate_data = trdata.reverse();
                            doSetPopups();
                        }, 100);
                    }else{
                        doNoProductsFound();
                        // userNotification("error", "Error:", "No rates found");
                    }

                    }else{
                        doNoProductsFound();

                    }
                }
            }
        });
         }else{

            // userNotification('error', 'Error:', error_message);
            userNotification('error', 'Error:', 'No loans found. Please give us a call to find a perfect rate for you');
            NProgress.done();

         }
    }

    function togglePurchase() {
        if($user_data.loantype === "Purchase"){
            $user_data.loantype = "Refinance";
        }else{
            $user_data.loantype = "Purchase";
        }
    }

    $: {
        // console.log("... in reactive statement");
        // console.log(rate_data);
        selected_rate_data = rate_data.filter((e)=>{
        // console.log(`testing ${e.t} against ${term}`);
        return e.t === term;
        });

    }

    function doLockRate(idx){
        console.log("doing lock rate");
        let selected_product = null;
        for(let i = 0; i < selected_rate_data.length; i++){
            if(selected_rate_data[i].idx === idx){
               $user_data.selected_product = selected_rate_data[i];
                break;
            }
        }
        // switch current flow to dp or dr
        $flow_steps.current_flow = ($user_data.loantype === "Purchase") ? "iqp" : "iqr";

        setTimeout(() => {
            // gtag_event('lock_rate', 'button_click', 'Rate Table Site', '/#/dfp_about_yourself');
        }, 10);

        setTimeout(() => {
            push("#/dfp_about_yourself");
        }, 200);

        // try{
            
        // }catch(err){
        //     console.log("gtag error route");
        //     push("#/dfp_about_yourself");
        // }

    }

</script>

<!-- <div id="payment_tooltip" role="tooltip">Monthly payment amounts do not include amounts for taxes, insurance premiums, private mortgage insurance (PMI), and mortgage insurance premiums (MIP). Your actual payment obligations will be greater.</div> -->

<!-- <div id="fees_tooltip" role="tooltip">Lender fees do not include third party fees (such as title, appraisal, and escrow fees, insurance payments, and FHA and VA loan fees) and certain fees that are based on options selected by the borrower (such as payments for discount points and rate lock extension fees).</div> -->

<Overlay bind:shown={show_overlay}>
<div class="busybox">
    <div class="busyboxindicatorcontainer">
        <img alt="searching rates" src="/img/ballbarprog.gif" />
    </div>

    <div class="busyitemcontainer {step_1_hidden}">
        <div class="busystepcontainer">
            <!-- <div class="bsiconcontainer"><img alt="semper" src="/img/semper_s.svg" /></div> -->
            <div class="bsdesccontainer">Getting You Home Faster</div>
        </div>
        <div class="busystepcontainer {step_2_hidden}">
            <!-- <div class="bsiconcontainer"><img alt="semper" src="/img/semper_s.svg" /></div> -->
            <div class="bsdesccontainer">Searching 30-year fixed...</div>
        </div>
        <div class="busystepcontainer {step_3_hidden}">
            <!-- <div class="bsiconcontainer"><img alt="semper" src="/img/semper_s.svg" /></div> -->
            <div class="bsdesccontainer">Searching 20-year fixed...</div>
        </div>
        <div class="busystepcontainer {step_4_hidden}">
            <!-- <div class="bsiconcontainer"><img alt="semper" src="/img/semper_s.svg" /></div> -->
            <div class="bsdesccontainer">Searching 15-year fixed...</div>
        </div>
    </div>
</div>
</Overlay>

<div class="maincontainer">

    <div class="navcontainer">
        <div class="logocontainer"><a href="/"><img src="/img/HomeEasy_logo_dark_grey-01.png" alt="Semper Home Loans Logo"><a href="/"></a></div>
        <div class="numbercontainer">
            <div class="phoneiconcontainer"><img src="/img/Phone_contact.svg" alt="Semper Home Loans Logo"></div>
            <div class="phonenumber">(866) 528-3814</div>
            <!-- <div class="signin">Sign In</div> -->
        </div>
    </div>

    <div class="titlecontainer">
        <div class="titletextcontainer">Mortgage rates today</div>
        <div class="titlecommentcontainer">Add your loan details and get customized rates for your situation.</div>
    </div>

    <div class="leftcontainer">
        <div class="lctitlecontainer">Your Details</div>

        <div class="labelrow">Loan Purpose</div>
        <div class="lcbuttonscontainer">
            <button on:click={()=>{togglePurchase();}} class="  {($user_data.loantype === "Purchase") ? "selected" : ""} leftbutton">Purchase</button>
            <button on:click={()=>{togglePurchase();}} class=" {($user_data.loantype === "Refinance") ? "selected" : ""} rightbutton">Refinance</button>
        </div>

        <div class="labelrow">Zip code</div>
        <div class="fieldrow">
            <input inputmode="numeric" on:keyup={()=>{clearFunction();}} bind:this={zipcode_element} bind:value={$user_data.propertyzipcode} class="progressforminput"  type="text" />
        </div>

        {#if $user_data.loantype === "Purchase"}

        <div class="labelrow">Purchase price</div>
        <div class="fieldrow"><input inputmode="numeric" bind:this={purchase_price_element} on:keyup={ () => { debouncedPurchasePriceChanged();}} bind:value={purchase_price} class="progressforminput"  type="text" /></div>
        
        <div class="labelrow">Down payment</div>
        <div class="downpaymentrow">
            <div class="ldpcontainer"><input inputmode="numeric" bind:this={down_payment_amount_element} on:keyup={ () => { debouncedDownPaymentAmountChanged();} } bind:value={down_payment_amount} class="progressforminput"  type="text" /></div>
            <div class="rdpcontainer"><input inputmode="numeric"  bind:this={down_payment_percent_element} on:keyup={ () => { debouncedDownPaymentPercentChanged();} } bind:value={down_payment_percent} class="progressforminput"  type="text" placeholder="%"/></div>
        </div>

        {:else}

        <div class="labelrow">Property value</div>
        <div class="fieldrow"><input inputmode="numeric"  on:keyup={ () => { debouncedPropertyValueChanged();}} bind:this={property_value_element} bind:value={property_value} class="progressforminput"  type="text" /></div>

        <div class="labelrow">Current balance</div>
        <div class="fieldrow"><input inputmode="numeric"  on:keyup={ () => { debouncedCurrentBalanceChanged();}} bind:this={current_balance_element} bind:value={current_balance} class="progressforminput"  type="text" /></div>

        {/if}


        <div class="labelrow">Credit score</div>
        <!-- <div class="fieldrow"><input inputmode="numeric" on:keyup={()=>{clearFunction();}} bind:this={credit_score_element} bind:value={$user_data.creditscore} class="progressforminput"  type="text" /></div> -->
        <div class="fieldrow creditscoreholder">
            <!-- <input inputmode="numeric" on:keyup={()=>{clearFunction();}} bind:this={credit_score_element} bind:value={$user_data.creditscore} class="progressforminput"  type="text" /> -->
            <select bind:this={credit_score_element}  bind:value={$user_data.creditscore} class="progressforminput">
                <option value="850">760 and above</option>
                <option value="759">740-759</option>
                <option value="739">720-739</option>
                <option value="719">700-719</option>
                <option value="699">680-699</option>
                <option value="679">660-679</option>
                <option value="659">640-659</option>
                <option value="639">620-639</option>
                <option value="619">600-619</option>
            </select>

        </div>


        <div class="checkboxrow">
            <label>
            <input bind:checked={$user_data.military} class="ratecheckbox" type="checkbox" /> Active Duty/Veteran?
            </label>
        </div>

        <div class="labelrow">Property type</div>
        <div class="selectrow">
            <select bind:value={$user_data.propertytype}>
                <option>Single Family</option>
                <option>Condo</option>
                <option>Multi-unit</option>
            </select>
        </div>

        {#if $user_data.loantype === "Purchase"}
        <div class="checkboxrow">
            <label>
            <input bind:checked={$user_data.firsttimebuyer} class="ratecheckbox" type="checkbox" /> First-time buyer?
            </label>
        </div>            
        {/if}

        <div class="seeratesbuttoncontainer">
            <button on:click={()=>{doSeeRates();}} class="darken bigredbutton">See rates</button>
        </div>
    </div>

    <div class="rightcontainer">
        <div class="ratetablecontainer">
            <div class="ratetablebuttoncontainer">
                <button on:click={()=>{term="30-year fixed";}} class="raise {(term === "30-year fixed") ? "selected" : ""}">30-year fixed</button>
                <button on:click={()=>{term="20-year fixed";}} class="raise {(term === "20-year fixed") ? "selected" : ""}">20-year fixed</button>
                <button on:click={()=>{term="15-year fixed";}} class="raise {(term === "15-year fixed") ? "selected" : ""}">15-year fixed</button>
            </div>
            <div class="ratetable">
                <div class="mrtable showmobile">
                    {#if selected_rate_data.length > 0}
                    {#each selected_rate_data  as rd, index}

                    <div class="mobilefullrowcontainer">
                        <div class="mobiletablecellcontainer">
                            <div class="tlabelcontainer">{rd.t} ({$user_data.loanType})</div>
                            <div class="amountcontainer">{rd.mp}</div>
                            <div class="tlabelcontainer">Per month</div>    
                        </div>
                        <div class="mobiletablecellcontainer">
                            <div class="raise  lockbuttoncontainer">
                                <button class="raise" on:click={()=>{doLockRate(rd.idx);}}>Lock rate</button>
                            </div>
                            <div class="boldtlabelcontainer">Fees {rd.po}</div>
                            <div class="boldtlabelcontainer">{rd.r} / {rd.a} APR</div>    
                        </div>    
                    </div>
                        
                    {/each}
                        
                    {/if}
                </div>
                <table class="rtable showdesktop">
                    <tr class="showdesktop">
                        <th style="min-width:100px">Term</th>
                        <th style="min-width:200px">Rate / APR</th>
                        <th>Mo. Payment</th>
                        <th>Fees</th>
                        <th></th>
                    </tr>
                    {#if selected_rate_data.length > 0}
                    {#each selected_rate_data as rd, index}
                    <tr class="showdesktop">
                        <td>{rd.t} <span class="loantype">({$user_data.loanType})</span></td>
                        <td>
                            <div class="tablecellcontainer">
                            <div class="tamountcontainer">{rd.r} / {rd.a}</div>
                                <div class="tlabelcontainer">Rate / APR</div>    
                            </div>
                        </td>
                        <td>
                            <div class="tablecellcontainer">
                                <div class="tamountcontainer">{rd.mp}</div>
                            <div class="tlabelcontainer"><div class="permonthpopper">Per month<div class="tooltiptext">Monthly payments do not include taxes, insurance premiums, or mortgage insurance. Your actual monthly housing expenses will be higher.</div></div></div>
                        </div>

                        </td>
                        <td>
                            <div class="tablecellcontainer">
                                <div class="tamountcontainer">{rd.po}</div>
                            <div class="tlabelcontainer pointspopper"><div class="permonthpopper">Points<div class="tooltiptext">Points on a mortgage are tradeoffs offered by the lender that allow the borrower some flexibility and additional options when paying off a mortgage. Opting for these discounts can lower your mortgage rate in exchange for an additional upfront fee.</div></div>
                        </div>

                        </td>

                        <td>
                            <div class="lockbuttoncontainer">
                                <button class="darken" on:click={()=>{doLockRate(rd.idx);}}>Lock rate</button>
                            </div>
                        </td>
                    </tr>
                        
                    {/each}
                        
                    {/if}

                </table>
            </div>
        </div>

        <div class="rightbottomcontainer">
            <div class="rbleftcontainer">
                <div class="rblefttitle">Personalize your rate</div>
                <div class="rbleftcomment">Want to know exactly what you can afford now? Customize and lock your rates based on your unique situation</div>
            </div>
            <div class="rbrightcontainer">
                <div class=" rbbuttonholder">
                    <div on:click={()=>{
                        // gtag_event('customize_and_lock', 'button_click', 'Rate Table Site', '/#/df');
                        // push("#/df")
                        }} class="darken customizelockcontainer">
                        <div class="lockimageholder"><img alt="lock" src="/img/lock.svg"></div>
                        <div class="cllableholder">Customize and Lock</div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>

    <div class="hrholder"></div>

    <div class="bottomcontainer" bind:this={bottom_container_element}>
        <CTA />
    </div>

    <div class="footercontainer">
        <FooterComponent />
    </div>

</div>

<div class="mobileholder">Would be switching to mobile layout here.</div>

<style>

.busybox {
    background-color: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    box-sizing: border-box;
}
.busyboxindicatorcontainer {
    margin-bottom: 40px;
}
.busyboxindicatorcontainer img {
    width: 100%;
    /* height: 64px; */
}
.busyitemcontainer {
    font-size: 2em;
    font-weight: bold;
    display:flex;
    flex-direction: column;
}
.busystepcontainer {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}
/* .busystepcontainer:not(:last-child) {
    margin-bottom: 40px;
} */
.bsiconcontainer {
    padding-right: 40px;
}
.bsiconcontainer img {
    width: 32px;
    height: 32px;
}

.creditscoreholder select{
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;

}


@media (max-device-width: 1024px), (max-width: 1023px) {
    .busybox {
        padding: 10px;
    }
    .busyboxindicatorcontainer {
        margin-bottom: 20px;
    }
    .busyboxindicatorcontainer img {
        width: 32px;
        height: 32px;
    }
    .busyitemcontainer {
        font-size: 1em;
        font-weight: bold;
    }
    .busystepcontainer {
        margin-bottom: 20px;
    }
    .bsiconcontainer {
        padding-right: 20px;
    }

}



.mobileholder {
    text-align: center;
    padding-top: 50px;
    font-size: 2em;
    font-weight: bold;
    display: none;
}

.maincontainer {
    width: 100vw;
    box-sizing: border-box;
    max-width: 1200px;
    /* padding: 10px; */
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    /* background-color: white; */
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-template-areas: "nc nc nc nc nc nc nc nc nc nc nc nc"
                        "tc tc tc tc tc tc tc tc tc tc tc tc"
                        "lc lc lc rc rc rc rc rc rc rc rc rc"
                        "hr hr hr hr hr hr hr hr hr hr hr hr "
                        "bc bc bc bc bc bc bc bc bc bc bc bc"
                         "fc fc fc fc fc fc fc fc fc fc fc fc";
    /* gap: 20px; */

}

.navcontainer {
    grid-area: nc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* width: 90%; */
    width: 100%;
    max-width: 100vw;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
}
.logocontainer img {
    /* height: 44px; */
    height: 36px;
}
.numbercontainer {
    display: flex;
    width: 150px;
    color: var(--placeholdergray);
}
.phoneiconcontainer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.phoneiconcontainer img {
    width:  1em;
    height: 1em;
}
.phonenumber {
    font-size: 1em;
    margin-left: 10px;
}
.titlecontainer {
    grid-area: tc;
}
.titletextcontainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 60px;
    font-size: 2.5em;
    font-weight: 600;
}
.titlecommentcontainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5em;
    margin-bottom: 40px;
    font-size: 1.25em;
    color: var(--placeholdergray);
}
.leftcontainer {
    grid-area: lc;
    border: 1px solid;
    border-color: #a1a6ad;
    border-radius: 5px;
    padding: 32px;
    max-height: 740px;
    max-width: 350px;
}
.lctitlecontainer {
    width: 100%;
    text-align: left;
    font-size: 1em;
    font-weight: 700;
    margin-bottom: 10px;
}
.labelrow {
    width: 100%;
    text-align: left;
    font-size: 0.75em;
    color: var(--placeholdergray);
    margin-top: 10px;
    margin-bottom: 6px;
}
.lcbuttonscontainer {
    width: 100%;
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
}
.lcbuttonscontainer button{
    flex: 1;
    padding: 10px;
    background-color: transparent;
    color: var(--placeholdergray);
    border: solid 1px;
    border-color: var(--placeholdergray);
}
.lcbuttonscontainer .leftbutton {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: none;
}
.lcbuttonscontainer .rightbutton {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
}
.fieldrow {
    width: 100%;
    padding: 0px;
}
.fieldrow input {
    width: 100%;
    font-size: 1em;
    box-sizing: border-box;
    background-color: var(--lightgray); 
    padding: 10px !important;   
}
.downpaymentrow {
    width: 100%;
    padding: 0px;
    display: flex;
}
.ldpcontainer {
    flex: 3;
}
.ldpcontainer input {
    width: 100%;
    box-sizing: border-box;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: none;
    background-color: var(--lightgray);    
    padding: 10px !important;   
}
.rdpcontainer {
    flex: 1;
}
.rdpcontainer input {
    width: 100%;
    box-sizing: border-box;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    background-color: var(--lightgray);    
    padding: 10px !important;   
}
.rdpcontainer input::placeholder {
    text-align: right;
}
.checkboxrow {
    width: 100%;
    display: flex;
    align-items: center;
}
.checkboxrow label {
    display:flex;
    align-items: center;
    font-size: 1em;
    color: var(--placeholdergray);
    margin-top: 30px;
    margin-bottom: 20px;
}
.ratecheckbox {
    appearance: none;
	-webkit-appearance: none;
	background-color: var(--lightgray);
	border: 1.5px solid;
    border-color: var(--placeholdergray);
	/* box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05); */
	padding: 16px;
	border-radius: 5px;
	display: inline-block;
	position: relative;
    margin-right: 20px;
}
.ratecheckbox:checked {
	background-color: var(--lightgray);
	border: 1.5px solid;
    border-color: var(--placeholdergray);
	color:var(--placeholdergray);
}
.ratecheckbox:checked:after {
	content: '\2714';
	font-size: 2em;
	position: absolute;
	top: 0px;
	left: 3px;
	color: var(--placeholdergray);
}

.selectrow {
    width: 100%;
}
.selectrow select {
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;
    width: 100%;
	background-color: var(--lightgray);
	border: 1.5px solid;
    border-color: var(--placeholdergray);
	color:var(--placeholdergray);
	border-radius: 5px;
    padding: 10px;
}
.seeratesbuttoncontainer {
    width: 100%;
    margin-top: 40px;
}
.seeratesbuttoncontainer button {
    width: 100%;
    padding: 18px;
    font-weight: 700;
    font-size: 1.25em;
    color: white;
    background-color: var(--semperred);
}

.rightcontainer {
    grid-area: rc;
    width: 100%;
    padding-left: 50px;
    /* padding-right: 50px; */
    box-sizing: border-box;
}
.ratetablecontainer {
    width: 100%;
}
.ratetablebuttoncontainer {
    width: 100%;
    display: flex;
}
.ratetablebuttoncontainer button {
    border: none;
    background-color: #e6e7e8;
    font-weight: 600;
    padding-left: 25px;
    padding-right: 25px;
    margin-right: 16px;
}
.ratetable {
    width: 100%;
    margin-top: 10px;
}
.rtable {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;
    border-bottom: solid 1px;
    border-top: solid 1px;
    border-color: #a1a6ad;
    /* table-layout: fixed; */
}
.rtable td {
    border-top: solid 1px;
    border-color: var(--placeholdergray);
}
.rtable th,td {
    text-align: center;
    font-weight: 500;
}
.rtable th:first-of-type,td:first-of-type {
    text-align: left;
}
.rtable td,th {
    padding-top: 30px;
    padding-bottom: 30px;
}

.tablecellcontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.tamountcontainer {
    width: 100%;
    text-align: center;
    font-size: 1.25em;
    line-height: 2em;
    font-weight: 600;
}

.tlabelcontainer { 
    width: 100%;
    text-align: center;
    color: var(--placeholdergray);
    font-size: .75em;
}
.permonthpopper {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-style: dashed !important;
    position: relative;
    display: inline-block;
}
.permonthpopper .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: white;
  color: var(--placeholdergray);
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  /* box-shadow: 5px 5px 15px 5px rbga(0, 0, 0, 0.50);  */
  /* box-shadow: 5px 5px 15px 5px rbga(0, 0, 0, 0.75);  */
  -webkit-box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.50); 
  box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.50);
  position: absolute;
  top: -8px;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, 100px);
  transition-duration: 0.3s;
  transition-property: transform;
  opacity: 0;
  padding: 20px 20px;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
}
.permonthpopper:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  /* transform: translate(0, -20px); */
  transform: translate(-50%, 25px);
  transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}
.permonthpopper .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%;  /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}


.pointspopper {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-style: dashed !important;
    position: relative;
    display: inline-block;
}
.pointspopper .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: white;
  color: var(--placeholdergray);
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  /* box-shadow: 5px 5px 15px 5px rbga(0, 0, 0, 0.50);  */
  /* box-shadow: 5px 5px 15px 5px rbga(0, 0, 0, 0.75);  */
  -webkit-box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.50); 
  box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.50);
  position: absolute;
  top: -8px;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, 100px);
  transition-duration: 0.3s;
  transition-property: transform;
  opacity: 0;
  padding: 20px 20px;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
}
.pointspopper:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  /* transform: translate(0, -20px); */
  transform: translate(-50%, 25px);
  transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}
.pointspopper .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%;  /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}

.lockbuttoncontainer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
}
.lockbuttoncontainer button {
    background-color: #f4f4f4;
    border: 1px solid;
    border-color: var(--semperred);
    color: var(--semperred);
    padding-left: 30px;
    padding-right: 30px;
    transition: all 0.25s linear;
}
/* .lockbuttoncontainer button:hover {
    background-color: var(--semperred);
    color: white;
    transform: translateY(-0.25em);
} */
.loantype {
    /* color: darkgray; */
    color: var(--placeholdergray);
    font-size: smaller;
}
.rightbottomcontainer {
    margin-top: 40px;
    background-color: white;
    border-radius: 5px;
    padding: 40px;
    display: flex;
    align-items: center;
}
.rbleftcontainer {
    flex: 1;
}
.rblefttitle {
    width: 100%;
    text-align: left;
    font-size: 1.5em;
    font-weight: 600;
}
.rbleftcomment {
    width: 100%;
    font-size: 1em;
    margin-top: 18px;
}
.rbrightcontainer {
    flex: 1;
}
.rbbuttonholder {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
}
.customizelockcontainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--semperred);
    border-radius: 5px;
    padding: 18px;
    cursor: pointer;
    transition: all 0.25s linear;
}
.lockimageholder img {
    width: 36px;
    height: 36px;
    filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(208deg) brightness(102%) contrast(102%);
}
.cllableholder {
    margin-left: 16px;
    color: white;
    font-size: 1.25em;
    font-weight: 700;
}

.hrholder {
    grid-area: hr;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid;
    border-color: var(--placeholdergray);
    /* margin-bottom: 40px; */
}

.bottomcontainer {
    grid-area: bc;
}

.footercontainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    grid-area: fc;
} 
button {
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;

}   
button.selected {
    background-color: var(--eclipse);
    /* color: white; */
    /* background-color: var(--semperred); */
    color: white;
}
.bigredbutton {
    background-color: var(--semperred);
    color: white;
    transition: all 0.25s linear;
}
.showmobile {
    display: none;
}
.stephidden {
    display: none;
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .showdesktop {
        display: none;
    }
    .showmobile {
        display: block;
    }
    .maincontainer {
        /* border-left: solid 2px red; */
        /* border-right: solid 2px red; */
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box !important;
        width: 100%;
        max-width: 411px !important;
        min-width: 411px !important;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        /* background-color: white; */
        /* display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "nc"
                             "tc"
                             "lc"
                             "rc"
                             "hr"
                             "bc"
                             "fc"; */

    }
    .navcontainer {
        width: 100% !important;
    }
    .titlecontainer {
        width: 100%;
        box-sizing: border-box;
    }
    .titletextcontainer {
        margin-top: 40px;
        font-size: 2em;
    }
    .titlecommentcontainer {
        margin-bottom: 40px;
    }
    .leftcontainer {
        width: 100%;
        box-sizing: border-box;
        border: none;
        max-width: 100%;
        padding-left: 0px;
        padding-right: 0px;    
    }
    .rightcontainer {
        padding-left: 0px;
        width: 100%;
        box-sizing: border-box;
        margin-top: 50px;
    }
    .ratetablebuttoncontainer {
        justify-content: space-between;
    }
    .ratetablebuttoncontainer button {
        padding-left: 12px;
        padding-right: 12px;
        font-size: 1em;
        margin-right: 0px;
    } 
    .rightbottomcontainer {
        width: 100%;
        background-color: transparent;
        border: none;
        flex-direction: column;
        align-items: unset;
        padding: 0px;
        box-sizing: border-box;
    }
    .rbleftcontainer {
        flex:none;
        width: 100%;
    }
    .rbrightcontainer {
        flex:none;
        width: 100%;
    }
    .ratetable {
        margin-top: 20px
    }
    .mrtable {
        width: 100%;
        border-bottom: solid 1px;
        border-color: var(--placeholdergray);

    }
    .mobilefullrowcontainer {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: solid 1px;
        border-color: var(--placeholdergray);
    }

    .mobiletablecellcontainer {
        /* width: 100%; */
        /* height: 100%; */
        /* box-sizing: border-box; */
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /* align-items: flex-start; */
    }
    .tlabelcontainer {
        width: 100%;
        text-align: left;
    }
    .amountcontainer {
        font-size: 2em;
        font-weight: 600;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .lockbuttoncontainer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-bottom: 6px;
    }
    .boldtlabelcontainer {
        text-align: right;
        padding-top: 6px;
    }
    .hrholder {
        width: 100%;
    }
    .rbleftcontainer {
        margin-top: 20px;
    }
    .rbleftcomment {
        line-height: 1.5em;
    }
    .rbbuttonholder {
        width: 250px;
        margin-left: 0px;
        margin-right: auto;
    }
    .customizelockcontainer {
        padding-top: 12px;
        padding-bottom: 12px;
        margin-top: 30px;
    }
    .bottomcontainer {
        width: 100%;
        box-sizing: border-box;
    }
    .footercontainer {
        width: 100%;
    }
}


</style>